import script from "./TransactionCodeManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionCodeManagement.vue?vue&type=script&setup=true&lang=js"

import "./TransactionCodeManagement.vue?vue&type=style&index=0&id=5a6c59b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a6c59b0"]])

export default __exports__